<template>
  <div class="order-path">
    <div class="order-path__header" v-if="!orderPathHeader">
      <div class="path__info">
        <span>{{ $t('route') }}</span>
        <span v-if="!isRental">
          <span v-if="!isSumaryOrder">&nbsp;{{ totalStoppoints }} {{ $t('stop_points') }}</span>
          <span v-if="isSumaryOrder && order.distance"> ( {{ order.distance }}km )</span>
          <span v-else-if="order.distance">&nbsp;•&nbsp;{{ order.distance }}km</span>
        </span>
      </div>

      <div
        v-if="editable && !isRental"
        class="path-update"
        data-test-id="updateBtn"
        @click="handleClickEditPath"
      >
        {{ $t('record.update') }}
        <SvgIcon class="edit-icon" width="20" height="20" icon="EditOutline" />
      </div>
    </div>
    <div v-else class="order-path__header custom">
      <div class="path__info">
        <div class="d-flex justify-space-between">
          <div class="my-2">
            <h2 class="mb-1">{{ $t('route') }}</h2>
            <span>{{ totalStoppoints }} {{ $t('stop_points') }}</span>
            <span v-if="order.distance">&nbsp;•&nbsp;{{ order.distance }}km</span>
          </div>
          <div>
            <img
              src="/assets/images/destination.svg"
              width="50"
              height="50"
              loading="lazy"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div id="record-detail-path" class="order-path__body" :class="{ full: isShowFullPath }">
      <Point
        v-for="(point, index) in orderPath"
        :dropoff="index !== 0"
        :hiddenLinkTail="index === totalStoppoints"
        :key="index"
        :name="point.name"
        :mobile="point.mobile"
        :cod="point.cod"
        :address="point.address"
        :remarks="point.remarks"
        :trackingNumber="point.tracking_number"
        :aptNumber="point.apt_number"
        :building="point.building"
        :status="point.status"
        :pointIndex="index"
        :orderRequests="order.requests"
        :confirmReturnTime="point.confirm_return_time"
        :loadingPointIndex="loadingPointIndex"
        :isSumaryOrder="isSumaryOrder"
        @returnPackageReceived="handleReturnPackageReceived"
      >
        <div class="record-detail__proof-info" v-if="isHaveProof">
          <v-tooltip v-if="point.proofInfo" right content-class="v-tooltip__custom-content">
            <v-avatar
              slot="activator"
              :size="32"
              class="grey lighten-3 proof-info__image"
              @click="handleClickProof(point.proofInfo)"
            >
              <img class="lazyload" :src="point.proofInfo" />
              <SvgIcon
                v-if="point.por_info"
                class="proof-info__return-status"
                height="20"
                width="20"
                icon="AttachedReturned"
              />
              <div class="proof-info__return-status pod" v-if="point.pod_info">
                {{ index }}
              </div>
            </v-avatar>
            <span v-if="point.por_info">{{ $t('record.por') }}</span>
            <span v-if="point.pod_info">{{ $t('record.pod') }}</span>
          </v-tooltip>
        </div>
      </Point>
    </div>
    <div v-if="showExpandBtn" class="order-path__expand-btn" @click="handleShowPullPath">
      <span>{{ expandLabel }}</span>
      <SvgIcon
        class="icon"
        height="22"
        width="14"
        :icon="isShowFullPath ? 'ArrowUp' : 'ArrowDown'"
      />
    </div>
    <ViewImageModal v-if="isHaveProof" ref="viewImageModal" :img-src="proofImage" />
  </div>
</template>

<script>
import Point from './order_path/Point'
import ViewImageModal from '@/components/ViewImageModal'

export default {
  name: 'OrderPath',
  props: {
    order: {
      type: Object
    },
    onClickEditPath: {
      type: Function
    },
    editable: {
      type: Boolean,
      default: false
    },
    expand: {
      type: Boolean,
      default: false
    },
    orderPathHeader: {
      type: Boolean
    },
    isSumaryOrder: {
      type: Boolean,
      default: false
    },
    isRental: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Point,
    ViewImageModal
  },
  data() {
    return {
      pathElm: null,
      showExpandBtn: false,
      isShowFullPath: false,
      proofImage: '',

      loadingPointIndex: -1
    }
  },
  computed: {
    orderPath() {
      let path = []
      if (this.order && this.order.path && this.order.path.length > 1) {
        if (this.isRental) {
          path.push(this.order.path[0])
        } else {
          path = this.order.path
        }

        path.forEach((p) => {
          p.proofInfo = this.checkProofPhoto(p)
        })
      }

      return path
    },
    totalStoppoints() {
      return this.orderPath.length - 1
    },
    expandLabel() {
      return this.isShowFullPath ? this.$t('collapse') : this.$t('record.order_path_expand')
    },
    isHaveProof() {
      let isExist = false

      this.orderPath.some((p) => {
        // por: proof of return
        // pod: proof of delivery

        if (p.por_info || p.pod_info) {
          const regex = /(http)?s?:?(\/\/[^"']*\.(?:png|jpg|jpeg|gif|png|svg))/g
          if (regex.test(p.por_info) || regex.test(p.pod_info)) {
            isExist = true
            return true
          }
        }
        return false
      })

      return isExist
    },
    failData() {
      let result = {}
      if (this.order && this.order.path && this.order.path.length > 0) {
        this.order.path.forEach((p) => {
          if (p.status === this.$constants.ORDER_STATUS.FAILED) {
            result = {
              fail_time: p.fail_time,
              fail_comment: p.fail_comment
            }
          }
        })
      }
      return result
    }
  },
  methods: {
    checkProofPhoto(p) {
      if (p.por_info || p.pod_info) {
        const regex = /(http)?s?:?(\/\/[^"']*\.(?:png|jpg|jpeg|gif|png|svg))/g
        if (regex.test(p.por_info) || regex.test(p.pod_info)) {
          return p.por_info || p.pod_info
        }
      }

      return ''
    },
    checkToShowExpandBtn() {
      if (this.pathElm) {
        const unknownHeight = 25
        const maxPathHeight = 200

        if (this.pathElm.scrollHeight - unknownHeight - maxPathHeight > 0) {
          this.showExpandBtn = true
        }
        // console.log('this.pathElm', this.pathElm.clientHeight, this.pathElm.offsetHeight, this.pathElm.scrollHeight, this.pathElm.scrollTop);
        // console.log(this.pathElm.getBoundingClientRect())
      }
    },
    handleShowPullPath() {
      this.isShowFullPath = !this.isShowFullPath
    },
    handleClickEditPath() {
      this.$emit('onClickEditPath')
    },
    handleClickProof(image) {
      this.proofImage = image
      this.$refs.viewImageModal.showModal = true
    },
    handleReturnPackageReceived(point_index) {
      const params = {
        token: this.$store.getters.token,
        order_id: this.order._id,
        point_index: point_index
      }

      this.loadingPointIndex = point_index
      this.$forceUpdate()
      this.$store
        .dispatch('confirmReturnedPackage', params)
        .then((response) => {
          if (response && response.status === 200) {
            this.order.path[point_index].confirm_return_time = response.data.confirm_return_time
          }
        })
        .catch((error) => {
          this.$store.dispatch('setSnackbar', {
            visible: true,
            title: error.response.data.title,
            color: 'error'
          })
        })
        .finally(() => {
          this.loadingPointIndex = -1
          this.$forceUpdate()
        })

      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.CLICK,
        this.$trackingEvents.EVENTS.CONFIRM_RETURN_PACKAGE_BTN,
        {
          order_id: params.order_id,
          point_index: params.point_index
        }
      )
    }
  },
  mounted() {
    this.pathElm = this.$el.querySelector('#record-detail-path')

    if (this.expand) {
      this.isShowFullPath = true
    } else {
      this.checkToShowExpandBtn()
    }
  }
}
</script>

<i18n>
  {
    "en": {
        "record": {
            "pod": "Proof of delivery",
            "por": "Proof of return"
        }
    },
    "vi": {
        "record": {
            "pod": "Bằng chứng giao hàng",
            "por": "Bằng chứng trả hàng"
        }
    }
  }
</i18n>

<style lang="scss" scoped>
$maxPathHeight: 200px;

.order-path {
  .order-path__header {
    padding: 16px 16px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;

    .path__info {
      > span:first-child {
        padding-right: 4px;
        font-weight: 500;
      }

      > span:last-child {
        font-weight: 500;
      }
    }

    .path-update {
      display: flex;
      align-items: center;
      color: #ff8200;
      cursor: pointer;

      .edit-icon {
        margin-left: 4px;
      }
    }
  }

  .order-path__header.custom {
    background: linear-gradient(167.77deg, #ff4d00 -2.62%, #ff8200 123.93%);
    color: white;
    padding: 12px 16px 0;

    .path__info {
      width: 100%;

      img {
        float: right;
      }
    }
  }

  .order-path__body {
    padding: 0 16px 16px;
    max-height: $maxPathHeight;
    overflow-y: hidden;

    &.full {
      max-height: initial;
      overflow-y: visible;
    }
  }

  .order-path__expand-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    border-top: 1px solid #f2f2f2;
    cursor: pointer;
    color: #7a8189;
    font-weight: 500;

    &:hover {
      background-color: #f8f8f8;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  .record-detail__proof-info {
    min-width: 40px;
    margin-bottom: 20px;
    padding-left: 8px;
    cursor: pointer;

    .proof-info__image {
      position: relative;

      .proof-info__return-status {
        position: absolute;
        bottom: -4px;
        right: -5px;

        &.pod {
          bottom: -2px;
          right: -3px;
          width: 15px;
          height: 15px;
          line-height: 15px;
          color: #fff;
          background: linear-gradient(162.99deg, #ffc496 -1.57%, #ff5f23 109.73%);
          border-radius: 3px;
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.order-path {
  .order-path__expand-btn {
    .icon {
      margin-left: 6px;

      svg {
        path {
          fill: #7a8189;
        }
      }
    }
  }
}
</style>
